import React from 'react';
import Box from '@mui/material/Box';
import LargeActionButton from './LargeActionButton';

interface PulsingActionButtonProps extends React.ComponentProps<typeof LargeActionButton> {
  marginBottom?: number | string;
  margin?: number | string;
  width?: number | string;
}

// Styled version of LargeActionButton with pulsing animation
const PulsingActionButton = ({
  marginBottom,
  margin,
  width = '100%',
  ...props
}: PulsingActionButtonProps) => (
  <Box
    sx={{
      width,
      textAlign: 'center',
      margin,
      marginBottom,
      animation: 'pulse 2s infinite ease-in-out',
      '@keyframes pulse': {
        '0%': {
          transform: 'scale(1)',
        },
        '50%': {
          transform: 'scale(1.1)',
        },
        '100%': {
          transform: 'scale(1)',
        },
      },
    }}
  >
    <LargeActionButton {...props} />
  </Box>
);

export default PulsingActionButton;
